.panel {
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  background: var(--surface-raised);
}

.trigger {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: var(--text);
  font: inherit;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.trigger:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}

/* The chevron points down when the panel is closed and up when it is open,
   which is the same state `aria-expanded` announces. */
.chevronOpen {
  transform: rotate(180deg);
}

.region {
  padding: 0 1rem 1rem;
  color: var(--text);
}
